module.exports = __webpack_public_path__ + "img/ics_o_search_gray.160b1dbd.svg";